module.exports = __webpack_public_path__ + "img/icon-radio.ca16e6c3.png";